import { get2 } from "@/shared/axios";
import { MenuDataTagCompact } from "@/shared/utils/interfaces";
import { useQuery } from "@tanstack/react-query";

// All tags in one list, for selects; filter on kind where needed
const useAllMenuDataTagsQuery = (enabled = true) => {
  const query = useQuery<MenuDataTagCompact[]>({
    queryKey: ["menuDataTags", "all"],
    queryFn: () => get2(`internal/secure/pos/v1/menu-data-tags/all`),
    staleTime: 5 * 60 * 1000,
    enabled,
  });

  return query;
};

export default useAllMenuDataTagsQuery;
